import styled from 'styled-components';

const Image = styled.img`
  opacity: ${props => (props.active ? `1` : `0`)};
  transition: opacity 0.3s ease-in;
  visibility: ${props => (props.active ? `visible` : `hidden`)};
`;

export default Image;
